// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Input from "react-toolbox/lib/input"
import DatePicker from "../../../components/DatePicker"

import * as strings from "../../../strings"

export default class CreateContract extends Component {
  props: {
    newContract: any,
    onChange: () => any,
    areInputFieldsInvalid: [],
  };

  render () {
    const { newContract, areInputFieldsInvalid, onChange } = this.props

    const err = strings.errorMessages.invalidValue

    return (
      <div className={style.mainContainer}>
        <div className={style.blueBar}>
        </div>
        <div className={style.firstDivisor}>
          <div className={style.firstLine}>
            <span><hr className={style.divider}/></span>
          </div>
          <div className={style.secondLine}>
            <span className={style.spanText}>{strings.paymentAgreements.createContract}</span>
          </div>
          <div className={style.thirdLine}>
            <span><hr className={style.divider}/></span>
          </div>
        </div>


        <div className={style.createContainer}>

          <Input
            className={style.inputFix}
            value={newContract.contractNumber}
            error={areInputFieldsInvalid[ 0 ] ? err : false }
            onChange={value => onChange( {
              contractNumber: value,
            } )}
            label={strings.paymentAgreements.contractNumber}
            maxLength={64}
            type="text" />
          <DatePicker
            error={areInputFieldsInvalid[ 1 ] ? err : false }
            label={strings.paymentAgreements.celebrationDate}
            onChange={value => onChange( {
              date: new Date( value ),
            } )}
            value={ newContract.date }
          />

          <DatePicker
            error={areInputFieldsInvalid[ 2 ] ? err : false }
            label={strings.generalStrings.emissionDate}
            onChange={value => onChange( {
              startDate: new Date( value ),
            } )}
            value={ newContract.startDate }
          />
          <DatePicker
            error={areInputFieldsInvalid[ 3 ] ? err : false }
            label={strings.generalStrings.expiryDate}
            onChange={value => onChange( {
              endDate: new Date( value ),
            } )}
            value={ newContract.endDate }
          />

          <Input
            className={style.inputFix}
            value={newContract.address}
            error={areInputFieldsInvalid[ 4 ] ? err : false }
            onChange={value => onChange( {
              address: value,
            } )}
            label={strings.generalStrings.address}
            maxLength={64}
            type="text" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DebtPhaseContracts/CreateContract/index.jsx